import { useState } from 'react'

import { Form as FormContainer } from 'components/Form'
import { CommonProps } from '../types'
import { Form } from './Form'
import { useConnectInstreamToGam } from './hooks/useConnectInstreamToGam'
import { schema, Schema, schemaDefault } from './schema'

export const InstreamForm = ({
  gamSetupOrder,
}: Pick<CommonProps, 'gamSetupOrder'>): JSX.Element => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const { connect, errors: apiErrors, loading } = useConnectInstreamToGam({ setIsDialogOpen })

  const formId = 'gam-connection-form-instream'

  return (
    <FormContainer<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={connect}
      schema={schema}
      schemaDefaults={schemaDefault(gamSetupOrder)}
    >
      {() => (
        <Form
          formId={formId}
          gamSetupOrder={gamSetupOrder}
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}
    </FormContainer>
  )
}
